import React from 'react'
import { AppRouter } from './router/AppRouter'


export const PortadaApp = () => {
  return (
    <div>
        <AppRouter/>
    </div>
  )
}